import Button from "@components/Button";
import InputWrapper, { PasswordInput } from "@components/Input";
import NearestRetailer from "@containers/HomePage/components/ui/NearestRetailer";
import { useLoginUserMutation } from "@features/auth/authApiSlice";
import { enqueueSnackbar, makeSelectToken } from "@features/auth/authSlice";
import { Modal } from "@mantine/core";
import { validator } from "@utils/helpers";
import Joi from "joi";
import { useState } from "react";
import { RiEdit2Line, RiKeyLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

const App = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openVisit, setOpenVisit] = useState(false);

  const handleToggleOpenVisit = () => setOpenVisit((prev) => !prev);

  const token = useSelector(makeSelectToken);

  const [userData, setUserData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({});

  const [loginUser, { isLoading: loginLoading }] = useLoginUserMutation();

  const handleForgetPassword = () => {
    navigate("/user/forget-password");
  };

  const handleChange = (name) => (event) => {
    setUserData((prev) => ({
      ...prev,
      [name]: event.target.value,
    }));
    if (name === "email") {
      if (errors["mobile_no"] && errors["mobile_no"] !== "") {
        setErrors((prev) => ({ ...prev, mobile_no: "" }));
      }
    }
    if (errors[name] && errors[name] !== "") {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationError = validator(loginSch, userData);
    if (validationError) {
      setErrors(validationError);
    } else {
      loginUser(userData)
        .unwrap()
        .then((res) => {
          if (res?.success) {
            navigate("/admin/dashboard/commerce");
          }
        })
        .catch((err) => {
          dispatch(
            enqueueSnackbar({
              message: err?.data?.msg || "Login Failed.",
              options: {
                variant: "warning",
              },
            })
          );
          setErrors(err?.data?.errors);
        });
    }
  };

  if (!token) {
    return (
      <div className='flex justify-center items-center h-[90vh]'>
        <div
          className='mx-auto mt-6 mb-12 bg-white max-w-md w-full rounded-lg p-8 box_shadow_login'
          id='main-login-div'
        >
          <h4 className='text-primary mb-0 text-xl'>Retailer Login.</h4>
          <p>
            Please visit{" "}
            <span className='text-blue-500' onClick={handleToggleOpenVisit}>
              the nearest store
            </span>{" "}
            to pre-order
          </p>
          <Modal
            size='xl'
            title='Search retailer nearest to your location.'
            opened={openVisit}
            onClose={handleToggleOpenVisit}
            className='w-4/5 md:w-3/4 lg:w-1/2'
          >
            <NearestRetailer />
          </Modal>
          <form
            className='mb-2 flex flex-wrap pt-0 lg:pt-2'
            onSubmit={handleSubmit}
          >
            <InputWrapper
              label={"Email Address / Mobile No."}
              value={userData?.email}
              onChange={handleChange("email")}
              className='w-full mb-3'
              error={errors?.email}
              type='string'
              leftSection={<RiEdit2Line />}
            />
            <PasswordInput
              label='Password'
              value={userData?.password || ""}
              onChange={handleChange("password")}
              className='w-full mb-3'
              error={errors?.password}
              leftSection={<RiKeyLine />}
            />
            <Button
              loading={loginLoading}
              type='submit'
              fullWidth
              className='mt-3'
            >
              Sign In
            </Button>
          </form>
          {/* <div className='flex w-full justify-end'>
            <button
              className='mt-1 mr-1 align-baseline text-xs text-black-400 hover:text-black-800'
              onClick={handleForgetPassword}
            >
              Forget Password? Contact
            </button>
          </div> */}
        </div>
      </div>
    );
  }

  return <Navigate to='/admin/dashboard/commerce' />;
};

export default App;

const loginSch = Joi.object({
  email: Joi.string().required().label("Email Address"),
  password: Joi.string().required().label("Password"),
});
